import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { UninstallAppRequest } from '../../shared/models/uninstallAppRequest';
import { IAppApiUninstall } from '../../shared/services/appApiFactory';
import { InstallMessengerRequest, MessengerInstalledApp, FacebookPage, GetFacebookUserPagesRequest } from '../models';
import { FacebookApi } from './facebookAppApi';


class MessengerApiService implements IAppApiUninstall, FacebookApi {
	private version = 'v1';

	public install(
		request: InstallMessengerRequest
	): Promise<void> {
		return api.send<InstallMessengerRequest, void>(
			'POST',
			urljoin(config().messengerHost, this.version, 'app', 'install'),
			request
		);
	}

	public uninstall(
		workspaceId: string,
		installId: string
	): Promise<void> {
		const request = {
			workspaceId,
			installId
		} as UninstallAppRequest;

		return api.send<UninstallAppRequest, void>(
			'POST',
			urljoin(config().messengerHost, this.version, 'app', 'uninstall'),
			request);
	}

	public getInstalledApp(
		workspaceId: string
	): Promise<MessengerInstalledApp> {
		return api.send<void, MessengerInstalledApp>(
			'GET',
			urljoin(config().messengerHost, this.version, `app?workspaceid=${workspaceId}`)
		);
	}

	public getUserPages(
		userAccessToken: string
	): Promise<FacebookPage[]> {
		const request = {
			userAccessToken,
			appType: 'messenger'
		} as GetFacebookUserPagesRequest;
		return api.send<GetFacebookUserPagesRequest, FacebookPage[]>(
			'POST',
			urljoin(config().messengerHost, this.version, 'pages'),
			request
		);
	}

	public canUninstall(): boolean {
		return true;
	}

	public getUninstallNotAllowedMessage(): string {
		return '';
	}
}

export const messengerApi = new MessengerApiService();
